import NavigableValidation from "./navigableValidation";
import NavigableValidator from "../navigableValidators/navigableValidator";
import FieldPresenceValidator from "../navigableValidators/fieldPresenceValidator";
import { IErrorNavOpts } from "~/models/validationError";
import { ValidationModalSection } from "~/models/navigableValidations/validationSections";
import DashboardConditionalLinkedDetailView from "../dashboardConditionalLinkedDetailView";
import ConditionalRuleValidator from "../navigableValidators/conditionalRuleValidator";

export default class DashboardConditionalLinkedDetailViewValidation extends NavigableValidation<DashboardConditionalLinkedDetailView> {
  model: DashboardConditionalLinkedDetailView;
  validators: NavigableValidator<DashboardConditionalLinkedDetailView>[] = [
    new FieldPresenceValidator({
      validatorKey: 'conditional_linked_detail_view_id',
      section: ValidationModalSection.Settings
    }),
    new ConditionalRuleValidator({
      validatorKey: "dashboard_conditional_linked_detail_view_conditional_rule_sets",
      section: ValidationModalSection.Settings,
      conditional: (model: DashboardConditionalLinkedDetailView, validatorKey) => {
        return Object.keys(model.dashboard_conditional_linked_detail_view_conditional_rule_sets).length > 0
      },
    }),
  ];

  errorNavOpts(validator, field: string, value?): IErrorNavOpts {
    let base = super.errorNavOpts(validator, field, value)
    const index = Object.keys(this.model.parent.dashboard_conditional_linked_detail_views).findIndex(key => key === this.model.client_id)
    Object.assign(base, {
      query: { selectedId: this.model.client_id },
      targetElementId: this.model.idForProp(field),
      hash: `${field}_${index}`
    });
    return base;
  }
}